import { inject, Injectable } from "@angular/core";

import { BehaviorSubject } from "rxjs";

import { FeatureFlagEnum, StorageKeyEnum } from "@shared/enums";
import { FeatureFlagService, LocalStorageService } from "@shared/services";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  isDarkTheme = new BehaviorSubject<boolean>(false);

  private readonly localStorageService = inject(LocalStorageService);

  private readonly featureFlagService = inject(FeatureFlagService);

  constructor() {
    if (!this.featureFlagService.isEnabled(FeatureFlagEnum.DARK_MODE)) {
      this.localStorageService.remove("theme");

      return;
    }

    const savedTheme = this.localStorageService.get(StorageKeyEnum.THEME);

    if (savedTheme) {
      this.setTheme(savedTheme === "dark");
    } else {
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

      this.setTheme(prefersDark);
    }
  }

  setTheme(isDark: boolean) {
    const theme = isDark ? "dark" : "light";

    this.isDarkTheme.next(isDark);
    document.documentElement.setAttribute("data-theme", theme);
    document.body.setAttribute("data-theme", theme);
    this.localStorageService.set(StorageKeyEnum.THEME, theme);
  }

  toggleTheme() {
    this.setTheme(!this.isDarkTheme.value);
  }
}
